import type { SVGProps } from "react";
export interface AmericanFootballIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AmericanFootballIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AmericanFootballIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.583 13.583a1.126 1.126 0 0 1 1.506-.078l.085.078 7.243 7.243.078.085a1.125 1.125 0 0 1-1.584 1.584l-.085-.078-7.243-7.243-.078-.085a1.125 1.125 0 0 1 .078-1.506m13.122-5.879a1.125 1.125 0 0 1 1.59 1.591l-.205.204.206.205.077.085a1.125 1.125 0 0 1-1.583 1.583l-.085-.077-.205-.205-.909.91.705.704.076.086a1.125 1.125 0 0 1-1.582 1.582l-.086-.077-.705-.705-.908.91.205.205.076.085a1.125 1.125 0 0 1-1.582 1.582l-.085-.076-.205-.205-.205.205a1.125 1.125 0 0 1-1.59-1.591l.203-.205-.204-.204a1.125 1.125 0 0 1 1.591-1.592l.204.204.91-.909-.705-.704a1.126 1.126 0 0 1 1.592-1.591l.703.703.91-.908-.204-.204-.077-.085a1.125 1.125 0 0 1 1.582-1.583l.085.077.205.204zm-1.122-6.121a1.126 1.126 0 0 1 1.506-.078l.085.078 7.243 7.243.078.085a1.125 1.125 0 0 1-1.584 1.584l-.085-.078-7.243-7.243-.078-.085a1.125 1.125 0 0 1 .078-1.506"
      />
      <path
        fill={color}
        d="M15.078 1.09C16.542.84 17.91.816 19.05.976c1.086.153 2.153.499 2.814 1.16l.12.13c.584.665.897 1.667 1.04 2.686.16 1.139.138 2.507-.112 3.97a17.2 17.2 0 0 1-13.989 13.99c-1.464.25-2.832.272-3.971.112-1.019-.143-2.02-.456-2.687-1.04l-.129-.12c-.661-.661-1.007-1.728-1.16-2.814-.16-1.139-.136-2.507.114-3.97a17.2 17.2 0 0 1 4.78-9.209 17.2 17.2 0 0 1 9.208-4.78Zm3.658 2.114c-.878-.123-2.01-.113-3.28.104a14.95 14.95 0 0 0-7.523 3.703l-.472.45a14.95 14.95 0 0 0-4.153 7.995c-.217 1.27-.227 2.402-.104 3.28.13.93.385 1.398.523 1.536l.069.058c.195.143.654.351 1.468.465.877.124 2.01.114 3.28-.102a14.95 14.95 0 0 0 7.994-4.155 14.95 14.95 0 0 0 4.155-7.995c.216-1.269.226-2.402.102-3.28-.114-.813-.322-1.272-.465-1.467l-.058-.069c-.138-.138-.606-.392-1.536-.523"
      />
    </svg>
  );
}
